// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Rating_rating__PKcsk {
    display: flex;
    direction: row;
  }
  
.Rating_star__VilC\\+ {
    display: inline-block;
    width: 20px;
    height: 20px;
    background-size: contain;
    background-repeat: no-repeat;
}`, "",{"version":3,"sources":["webpack://./src/components/Rating.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,cAAc;EAChB;;AAEF;IACI,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,wBAAwB;IACxB,4BAA4B;AAChC","sourcesContent":[".rating {\n    display: flex;\n    direction: row;\n  }\n  \n.star {\n    display: inline-block;\n    width: 20px;\n    height: 20px;\n    background-size: contain;\n    background-repeat: no-repeat;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"rating": `Rating_rating__PKcsk`,
	"star": `Rating_star__VilC+`
};
export default ___CSS_LOADER_EXPORT___;
